// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import Skeleton from '@tcp/core/src/components/common/atoms/Skeleton';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : props.theme.colorPalette.white};
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  ${(props) => (!isEmpty(props.spacingTop) ? `margin-top: ${props.spacingTop}px;` : ``)}
  ${(props) => (!isEmpty(props.spacingBottom) ? `margin-bottom: ${props.spacingBottom}px;` : ``)}
`;

export const StyledSkeleton = styled(Skeleton)`
  justify-content: center;
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  .skeleton-col {
    height: 200px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      &:nth-child(n + 4) {
        display: none;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 285px;
      &:nth-child(n + 5) {
        display: none;
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 387px;
      &:nth-child(n + 8) {
        display: none;
      }
    }
  }
`;
